<template>
	<v-container class="login-container">
		<v-layout class="login-layout" wrap justify-center>
			<v-layout class="login_background" flex-wrap justify-center align-center>
				<v-flex xs6 v-if="nowWidth > 1090">
					<div>
						<v-img height="100vh" src="/image/login_bg.png"></v-img>
					</div>
				</v-flex>
				<v-flex md6 xs12>
					<div></div>
					<div class="block-text">
						인증되지 않은 계정입니다.
					</div>
					<div style="padding:0px 10px">
						<p class="block-grey mb-8">서비스 이용을 위해 담당자에게 문의해주세요.</p>
						<p class="block-grey mb-1">담당자1: 이규화 (010-5059-6778)</p>
					</div>
				</v-flex>
			</v-layout>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			screenWidth: 0, //창크기
		}
	},
	created() {
		this.screenWidth = window.innerWidth
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {},
}
</script>
